let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined,
  search_strategy_id: undefined,
  combination: [
    {
      support_type: undefined,
      search_filter_id: undefined,
      type: undefined,
    },
  ],
  link: {
    dynamic_dashboard_id: undefined,
  },
};

model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "",
  defaultSort: ["", ""],
  fields:
    "id,search_strategy_id,code,link,name,created_time,creator_id,last_modified_time,last_modifier_id",
  filters: "",
  dataSearch: {
    value: {
      search_strategy_id: "",
      "link.dynamic_dashboard_id": "",
    },
    operator: {
      search_strategy_id: "=",
      "link.dynamic_dashboard_id": "=",
    },
  },
};

model.combinationTypeOptions = [
  {
    value: "default",
    labelKey: "t-combination-type-default",
  },
  {
    value: "user_value",
    labelKey: "t-combination-type-user-value",
  },
];

model.supportTypeOptions = [
  {
    value: "tong_hop",
    labelKey: "t_support_type_tong_hop",
  },
  {
    value: "chi_tiet",
    labelKey: "t_support_type_chi_tiet",
  },
];

export default model;
